import * as React from 'react';
import {useSelector} from 'react-redux';
import {Trans} from '@lingui/macro';

import FlatButton from '@components/FlatButton';
import EscIcon from '@components/Icons/CloseIcon';
import EmailIcon from '@components/Icons/EmailIcon';

import s from './EmailPreview.module.css';

export default function EmailPreview({close, startTest, test}) {
  const previewMetadata = test.getIn(['jsonData', 'theme', 'preview']) || {
    tag: 'asd',
    preview: {
      img: {
        alt: 'Francesco Quesada',
        src: null,
      },
      time: 'Friday 12 at 09:00',
      type: 'email',
      sender: 'Monica Lanfranchi',
      content: '<p>Hello {{firstName}}, <br><br>placeholder message</p>',
      subject: 'Coaching course preparatory activities',
    },
    duration: '30 Min',
  };

  const user = useSelector(state => state.getIn(['user', 'data']));

  return (
    <>
      <div className={s.Container}>
        <div className={s.Header}>
          <div className={s.MailIcon}>
            <EmailIcon />
            <div>
              <Trans id="calendar.preview_mail">Hai una nuova mail!</Trans>
            </div>
          </div>

          <FlatButton onClick={close}>
            <EscIcon customColor={true} />
          </FlatButton>
        </div>

        <div className={s.Body}>
          <div className={s.Mail}>
            <div className={s.MailHeader}>
              <div className={s.Img}>
                {previewMetadata.getIn(['img', 'src']) ? (
                  <img
                    src={previewMetadata.getIn(['img', 'src'])}
                    alt={previewMetadata.getIn(['img', 'alt'])}
                  />
                ) : (
                  <div className={s.Placeholder} />
                )}
              </div>
              <div>
                <div className={s.Sender}>{previewMetadata.get('sender')}</div>
                <div>{previewMetadata.get('time')}</div>
              </div>
            </div>

            <div className={s.Content}>
              <div>A: {user.get('email')}</div>
              <div
                className={s.Text}
                dangerouslySetInnerHTML={{
                  __html: previewMetadata
                    .get('content')
                    ?.replace('{{firstName}}', user.get('firstName')),
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <FlatButton className={s.Footer} onClick={startTest}>
        <Trans id="calendar.preview_start">Inizia attività</Trans>
      </FlatButton>
    </>
  );
}
